<template>
  <div class="finish-box">
    <i class="finish-icon"></i>
    <div class="finish-title">激活成功</div>
    <div class="finish-notice">
      恭喜您已经完成激活
      <span class="waite-time">{{ waitingTime }}s</span>后将自动跳转
    </div>
    <a-button size="large" class="finish-btn" @click="returnBack" type="primary">立即学习</a-button>
  </div>
</template>

<script>


export default {
  name: 'payfinish',
  components: {},
  data() {
    return {
      goodsGuid:'',
      intPay: null,
      waitingTime: 10,
    }
  },
  mounted() {
    this.goodsGuid = this.$route.params.id;

    let that = this;
    let int = setInterval(() => {
      if (that.waitingTime <= 0) {
        clearInterval(int);
        that.returnBack();
      }
      that.waitingTime -= 1;
    }, 1000);
  },
  methods: {
    //返回
    returnBack() {
      clearInterval(this.intPay);
      this.$router.push(`/course-info/${this.goodsGuid}`);
    },
  }
}


</script>

<style scoped lang="scss">
@import "./pay-finish.scss";
</style>